import type { Language } from '@inflearn/i18n-tools';

export const getCountryCode = ({ lang }: { lang: Language }) => {
  if (lang === 'ko') {
    return '82';
  }

  if (lang === 'en') {
    return '1';
  }

  if (lang === 'ja') {
    return '81';
  }

  if (lang === 'vi') {
    return '84';
  }

  return '82';
};
